import type { AmsCodeListFieldsFragment } from '@oysterjs/ais/api/graphql';

export type CodeOption = AmsCodeListFieldsFragment['options'][number];

// Documents and reviewers vary in case and spacing ("FEMALE", " Female "), so both
// sides are compared trimmed, with runs of whitespace collapsed, in lowercase.
const normalized = (value: string) => value.trim().replace(/\s+/g, ' ').toLowerCase();

/**
 * The option a value names, by its code first and then by its label: extraction and
 * Epic's own reads give the label, a pick gives the code, and a code is the more exact.
 */
export function findAmsCodeOption(
  options: readonly CodeOption[],
  value: string | null | undefined
): CodeOption | undefined {
  if (!value || !normalized(value)) {
    return undefined;
  }
  const wanted = normalized(value);
  return (
    options.find((option) => normalized(option.code) === wanted) ??
    options.find((option) => normalized(option.label) === wanted)
  );
}
